import React, { useEffect, useRef } from 'react';
interface ScrollRevealProps {
  children: React.ReactNode;
  delay?: number;
}
const ScrollReveal = ({
  children,
  delay = 0
}: ScrollRevealProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('active');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [delay]);
  return <div ref={ref} className="reveal" style={{
    transitionDelay: `${delay}ms`
  }} data-id="element-546">
      {children}
    </div>;
};
export default ScrollReveal;